import { NON_RENTABLE_CONFIG } from './non-rentable.config';
import { LEASE_CONFIG, LEASE_CONFIG_ESTIMATE } from './lease.config';
import { UNACCOUNTED_CONFIG } from './unaccounted.config';
import { AVAILABILITY_CONFIG } from './availability.config';
import { TENANT_CONFIG } from './tenant.config';

export const DETAILS_OVERLAY_CONFIGS = {
  availability: AVAILABILITY_CONFIG,
  tenancy: TENANT_CONFIG,
  lease: LEASE_CONFIG,
  nonrentable: NON_RENTABLE_CONFIG,
  unaccounted: UNACCOUNTED_CONFIG,
};

export const DETAILS_OVERLAY_ESTIMATION_CONFIGS = {
  lease: LEASE_CONFIG_ESTIMATE,
};
